// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-a2db0026]{display:none}.breadcrumbs .sf-breadcrumbs__list-item .sf-link.current[data-v-a2db0026]{font-style:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
